module.exports = __webpack_public_path__ + "img/ae.9fd1fcbf.svg";